import { render, staticRenderFns } from "./PickUpConfirmPop.vue?vue&type=template&id=420656ca"
import script from "./PickUpConfirmPop.vue?vue&type=script&lang=js"
export * from "./PickUpConfirmPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420656ca')) {
      api.createRecord('420656ca', component.options)
    } else {
      api.reload('420656ca', component.options)
    }
    module.hot.accept("./PickUpConfirmPop.vue?vue&type=template&id=420656ca", function () {
      api.rerender('420656ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/PickUpConfirmPop.vue"
export default component.exports